import { useState } from 'react';
import service from "../../services/Service";
import { Button, notification } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import Loading from "../../utils/loading";

import { withLocale } from '../../l10n';

function SettingsKiconex({ lang }) {
  // ===== 1. ESTADOS =====
  const [loading, setLoading] = useState(false);

  // ===== 2. HANDLERS =====
  const refreshTenants = async () => {
    setLoading(true);
    try {
      await service.post("tenants/refresh")
      notification["success"]({
        message: lang.handle("Actualizado con exito"),
      });
    } catch (error) {
      console.error("Error fetching tenants:", error);
      notification["error"]({
        message: lang.handle("Error al actualizar listado"),
      });
    } finally {
      setLoading(false);
    }
  };

  // ===== 3. RENDER =====
  return (
    <div>
      {loading && <Loading loading={loading} />}
      <div className='card card-body'>
        <h4 className="p-3"> {lang.handle("Actualización de listados")} </h4>

        <div className="row mb-2">
          <div className="col col-sm-3 my-auto">
            <div className='px-5'>{lang.handle("Actualizar listado de organizaciones")}</div>
          </div>
          <div className="col col-sm-9">
            <Button
              type="primary"
              icon={<ReloadOutlined />}
              onClick={refreshTenants}
              disabled={loading}
            >
              {lang.handle('Actualizar listado')}
            </Button>
          </div>
        </div>

      </div>
    </div>
  );
}

export default withLocale(SettingsKiconex);
